import React, { createElement, Fragment } from 'react';
import Collapsible from 'react-collapsible';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'

import Box from '../Box';
import Text from '../Text';
import Flex from '../Flex';

const Trigger = ({ isOpen, children }) => (
  <Flex cursor="pointer" alignItems="center">
    {children}
    {createElement(isOpen ? IoIosArrowUp : IoIosArrowDown, { size: '1.5em', style: { marginLeft: '0.5em' } })}
  </Flex>
)

const List = ({ title, list, ordered, collapsible, ...props }) => {
  const heading = <Text.h1>{title}</Text.h1>
  const content = list ? (
    <Box is={ordered ? 'ol' : 'ul'}>
      {list.map(({ label, description }, index) => (
        <Box is="li" mt="0.5em" key={index}>
          <Text fontWeight="bold">{label}</Text>
          {description && (
            <Text>{description}</Text>
          )}
        </Box>
      ))}
    </Box>
  ) : null
  return (
    <Box {...props}>
      {collapsible ? (
        <Collapsible
          trigger={<Trigger>{heading}</Trigger>}
          triggerWhenOpen={<Trigger isOpen>{heading}</Trigger>}
        >
          {content}
        </Collapsible>
      ) : (
        <Fragment>
          {heading}
          {content}
        </Fragment>
      )}
    </Box>
  )
}


export default List;
